import React, { useState, useEffect, useRef, useCallback } from "react";
import "./BrandSelect.css";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import { useSelector } from "react-redux";
import { selectAllBrands } from "../../../../features/listingPage/listingPageSlice";
import { selectUser } from "../../../../features/auth/authSlice";

function BrandSelect({ onSelect, closeBrandSelect, previouslySelectedBrands }) {
  const brands = useSelector(selectAllBrands);
  const [selectedBrands, setSelectedBrands] = useState(
    previouslySelectedBrands || []
  );
  const [searchQuery, setSearchQuery] = useState("");
  const userDetail = useSelector(selectUser);

  const handleCheckboxChange = (brand) => {
    setSelectedBrands((prevSelectedBrands) =>
      prevSelectedBrands.includes(brand)
        ? prevSelectedBrands.filter((b) => b !== brand)
        : [...prevSelectedBrands, brand]
    );
  };

  const handleMobileCheckboxChange = (brand) => {
    setSelectedBrands((prevSelectedBrands) => {
      const updatedBrands = prevSelectedBrands.includes(brand)
        ? prevSelectedBrands.filter((b) => b !== brand)
        : [...prevSelectedBrands, brand];
      onSelect({ brands: updatedBrands });
      return updatedBrands;
    });
  };

  const handleApplyClick = () => {
    onSelect({ brands: selectedBrands });
  };

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Create a ref to the component
  const brandSelectRef = useRef(null);

  const handleClickOutside = useCallback(
    (event) => {
      if (
        brandSelectRef.current &&
        !brandSelectRef.current.contains(event.target)
      ) {
        closeBrandSelect();
      }
    },
    [closeBrandSelect]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const filteredBrands = brands.filter((data) =>
    data.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div ref={brandSelectRef} className="brand-select-container">
      <div className="brand-select-btn-container">
        <span>{selectedBrands.length} selected</span>
        <div className="brand-select-btn-contain">
          <button className="brand-select-btn-apply" onClick={handleApplyClick}>
            Apply
          </button>
          <button
            className="brand-select-btn-clear"
            onClick={() => setSelectedBrands([])}
          >
            Clear
          </button>
        </div>
      </div>
      <div className="brand-select-search-container">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInputChange}
        />
        <SearchSharpIcon className="brand-select-search-icon" />
      </div>
      <div className="brand-select-option-container">
        {filteredBrands.map((data, index) => (
          <div
            className={`brand-name-checkbox${
              selectedBrands.includes(data) ? "-selected" : ""
            }`}
            key={index}
          >
            <input
              type="checkbox"
              checked={selectedBrands.includes(data)}
              onChange={() => handleCheckboxChange(data)}
              // onClick={handleApplyClick}
            />
            <span>{data}</span>
          </div>
        ))}
      </div>
      <div className="mobile-brand-select-option-container">
        {filteredBrands.map((data, index) => (
          <div
            className={`brand-name-checkbox${
              selectedBrands.includes(data) ? "-selected" : ""
            }`}
            key={index}
          >
            <input
              type="checkbox"
              checked={selectedBrands.includes(data)}
              onChange={() => handleMobileCheckboxChange(data)}
              // onClick={handleApplyClick}
            />
            <span className="brand-name-span-d">{data}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BrandSelect;
